export enum ContactTypeEnum {
  SALES = 'SALES',
  RESERVATION = 'RESERVATION',
  ACCOUNTING = 'ACCOUNTING',
  ESCALATION = 'ESCALATION',
}
